import { useEffect, useState } from 'react';
import { getAllMedications } from 'api/operation/pageManagement';

interface UseAllMedicationsResult {
    medications: string[];
    loading: boolean;
    error: string | null;
    refetch: () => void;
}

const useAllMedications = (): UseAllMedicationsResult => {
    const [medications, setMedications] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchMedications = async () => {
        if (loading) return;

        try {
            setLoading(true);
            setError(null);
            const result = await getAllMedications();

            if (!result.error && result.data?.data) {
                setMedications(result.data.data);
            } else {
                setError(result.error || 'Failed to fetch medications');
                setMedications([]);
            }
        } catch (e) {
            console.error('Error fetching medications:', e);
            setError('Failed to fetch medications');
            setMedications([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMedications();
    }, []);

    return {
        medications,
        loading,
        error,
        refetch: fetchMedications,
    };
};

export default useAllMedications;
